
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Prompt, Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import { Button, Row, Col, ButtonToolbar, ButtonGroup, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown, Nav, NavItem, NavLink } from 'reactstrap';
import { Formik, Field, Form } from 'formik';
import DocumentTitle from 'react-document-title';
import classNames from 'classnames';
import LoadingIcon from 'mdi-react/LoadingIcon';
import CheckIcon from 'mdi-react/CheckIcon';
import DatePicker from '../../components/custom/DatePicker';
import NaviBar from '../../components/custom/NaviBar';
import DropdownField from '../../components/custom/DropdownField';
import AutoCompleteField from '../../components/custom/AutoCompleteField';
import RintagiScreen from '../../components/custom/Screen';
import ModalDialog from '../../components/custom/ModalDialog';
import { showNotification } from '../../redux/Notification';
import { registerBlocker, unregisterBlocker } from '../../helpers/navigation'
import { isEmptyId, getAddDtlPath, getAddMstPath, getEditDtlPath, getEditMstPath, getNaviPath, getDefaultPath } from '../../helpers/utils'
import { toMoney, toLocalAmountFormat, toLocalDateFormat, toDate, strFormat } from '../../helpers/formatter';
import { setTitle, setSpinner, setTopbarMenu, hideTopbarMenu, hideSidebar, registerTopbarLeft, registerTopbarCenter, registerTopbarRight } from '../../redux/Global';
import { RememberCurrent, GetCurrent } from '../../redux/Persist'
import { getNaviBar } from './index';
import SubTestReduxObj from '../../redux/SubTest';
import Skeleton from 'react-skeleton-loader';
import ControlledPopover from '../../components/custom/ControlledPopover';
import log from '../../helpers/logger';
import { Elements, StripeProvider } from 'react-stripe-elements';
import StripeCheckoutForm from '../../components/custom/StripeCheckoutForm';
import { loadPage } from '../../redux/Plan';
import VwRUsrSubDtlReduxObj, { ShowMstFilterApplied } from '../../redux/VwRUsrSubDtl';

const API_KEY = 'pk_test_f8cR5En7mRuX2lhQQAJaUO9x';

class Payment extends RintagiScreen {
  constructor(props) {
    super(props);
    
    this.GetReduxState = () => (this.props.SubTest || {});
    this.blocker = null;
    this.titleSet = false;
    this.MstKeyColumnName = 'subTestId2';
    this.SystemName = 'Rintagi';
    this.confirmUnload = this.confirmUnload.bind(this);
    this.hasChangedContent = false;
    this.setDirtyFlag = this.setDirtyFlag.bind(this);
    this.AutoCompleteFilterBy = (option, props) => { return true };
    this.OnModalReturn = this.OnModalReturn.bind(this);
    this.mobileView = window.matchMedia('(max-width: 1200px)');
    this.mediaqueryresponse = this.mediaqueryresponse.bind(this);

    this.state = {
      submitting: false,
      ScreenButton: null,
      key: '',
      Buttons: {},
      ModalColor: '',
      ModalTitle: '',
      ModalMsg: '',
      ModalOpen: false,
      ModalSuccess: null,
      ModalCancel: null,
      isMobile: false,
      reduxRefreshed: false,
    }

    // this.props.setSpinner(true);

    this.props.hideSidebar(true);
    this.props.hideTopbarMenu(true);
    this.props.registerTopbarLeft("","",true,"","");
    this.props.registerTopbarCenter(this.props.history.location.pathname, true, 'Payment');
    this.props.registerTopbarRight(this.Close.bind(this), this.props.history.location.pathname, true, 'close');

    // Promise.all([
    //   // this.props.loadPage(),
    // ]).catch(error => {

    // }).finally(() => {
    //   setTimeout(() => this.props.setSpinner(false), 500);
    //   this.setState({ reduxRefreshed: true });
    // })

    // this.props.setTopbarMenu(true);

    if (!this.props.suppressLoadPage && this.props.history) {
      RememberCurrent('LastAppUrl', (this.props.history || {}).location, true);
    }

    if (!this.props.suppressLoadPage) {
      this.props.setSpinner(true);
    }
  }

  Close() {
    this.props.history.push('/dashboard');
  }

  mediaqueryresponse(value) {
    if (value.matches) { // if media query matches
      this.setState({ isMobile: true });
    }
    else {
      this.setState({ isMobile: false });
    }
  }

  subUsrId2InputChange() { const _this = this; return function (name, v) { const filterBy = ''; _this.props.SearchsubUsrId2(v, filterBy); } }/* ReactRule: Master Record Custom Function */
  /* ReactRule End: Master Record Custom Function */

  /* react related stuff */
  static getDerivedStateFromProps(nextProps, prevState) {
    const nextReduxScreenState = nextProps.SubTest || {};
    const buttons = nextReduxScreenState.Buttons || {};
    const revisedButtonDef = super.GetScreenButtonDef(buttons, 'Mst', prevState);
    const currentKey = nextReduxScreenState.key;
    const waiting = nextReduxScreenState.page_saving || nextReduxScreenState.page_loading;
    let revisedState = {};
    if (revisedButtonDef) revisedState.Buttons = revisedButtonDef;

    if (prevState.submitting && !waiting && nextReduxScreenState.submittedOn > prevState.submittedOn) {
      prevState.setSubmitting(false);
    }

    return revisedState;
  }

  confirmUnload(message, callback) {
    const SubTestState = this.props.SubTest || {};
    const auxSystemLabels = SubTestState.SystemLabel || {};
    const confirm = () => {
      callback(true);
    }
    const cancel = () => {
      callback(false);
    }
    this.setState({ ModalOpen: true, ModalSuccess: confirm, ModalCancel: cancel, ModalColor: 'warning', ModalTitle: auxSystemLabels.UnsavedPageTitle || '', ModalMsg: message });
  }

  setDirtyFlag(dirty) {
    /* this is called during rendering but has side-effect, undesirable but only way to pass formik dirty flag around */
    if (dirty) {
      if (this.blocker) unregisterBlocker(this.blocker);
      this.blocker = this.confirmUnload;
      registerBlocker(this.confirmUnload);
    }
    else {
      if (this.blocker) unregisterBlocker(this.blocker);
      this.blocker = null;
    }
    if (this.props.updateChangedState) this.props.updateChangedState(dirty);
    this.SetCurrentRecordState(dirty);
    return true;
  }

  componentDidMount() {
    this.mediaqueryresponse(this.mobileView);
    this.mobileView.addListener(this.mediaqueryresponse) // attach listener function to listen in on state changes
    const isMobileView = this.state.isMobile;
    const useMobileView = (isMobileView && !(this.props.user || {}).desktopView);
    const suppressLoadPage = this.props.suppressLoadPage;
    if (!suppressLoadPage) {
      const { mstId } = { ...this.props.match.params };
      if (!(this.props.SubTest || {}).AuthCol || true) {
        this.props.LoadPage('Mst', { mstId: mstId || '_' });
      }
      if (!(this.props.VwRUsrSubDtl || {}).AuthCol || true) {
        this.props.LoadUserPage('SearchList', { mstId: mstId || '_' });
        this.props.LoadUserInitPage({ keyId: null });
      }
    }
    else {
      return;
    }
  }

  componentDidUpdate(prevprops, prevstates) {
    const currReduxScreenState = this.props.SubTest || {};

    if (!this.props.suppressLoadPage) {
      if (!currReduxScreenState.page_loading && this.props.global.pageSpinner) {
        const _this = this;
        setTimeout(() => _this.props.setSpinner(false), 500);
      }
    }

    const currMst = currReduxScreenState.Mst || {};
    this.SetPageTitle(currReduxScreenState);
    if (prevstates.key !== currMst.key) {
      if ((prevstates.ScreenButton || {}).buttonType === 'SaveClose') {
        const currDtl = currReduxScreenState.EditDtl || {};
        const dtlList = (currReduxScreenState.DtlList || {}).data || [];
        const naviBar = getNaviBar('Mst', currMst, currDtl, currReduxScreenState.Label);
        const searchListPath = getDefaultPath(getNaviPath(naviBar, 'MstList', '/'))
        this.props.history.push(searchListPath);
      }
    }
  }

  componentWillUnmount() {
    if (this.blocker) {
      unregisterBlocker(this.blocker);
      this.blocker = null;
    }
    this.mobileView.removeListener(this.mediaqueryresponse);
  }

  // SubmitCreditCardPayment = (values, { setSubmitting }) => {
  //   // log.debug('get business verification submitted', values);
  //   this.IsFormSubmit = false;
  //   this.setState({ submittedOn: Date.now(), submitting: true, setSubmitting: setSubmitting });

  //   log.debug(values.creditCardsHistory);

  //   this.props.setSpinner(true);

  //   const index = parseFloat(values.creditCardsHistory) - 1;

  //   if (values.creditCardsHistory !== undefined) {
  //     this.props.submitCreditCardPayment(
  //       this.props.creditCards.currentCreditCards.cardsHistory[index].cardName,
  //       this.props.creditCards.currentCreditCards.cardsHistory[index].cardNumber,
  //       this.props.creditCards.currentCreditCards.cardsHistory[index].expiryMonth,
  //       this.props.creditCards.currentCreditCards.cardsHistory[index].expiryYear,
  //       this.props.creditCards.currentCreditCards.cardsHistory[index].cvv,
  //     );
  //   }
  //   else {
  //     this.props.submitCreditCardPayment(
  //       values.cardName,
  //       values.cardNumber,
  //       values.expiryMonth,
  //       values.expiryYear,
  //       values.cvv,
  //       values.saveCard,
  //     );
  //   }

  //   this.FormAction = undefined;
  // }

  CreditCardChanged = (token) => {
    // this.props.chargeCreditCard(token, 'usd', 2000, 'test charge', true)
    //   .then(
    //     (result) => {
    //       log.debug('submit done', result);

    //       // test preauth capture
    //       this.props.chargePreAuth(result.chargeId)
    //         .then(
    //           (result) => {
    //             log.debug('pre auth captureed', result);
    //           }
    //         );

    //       setTimeout(() => {
    //         this.props.history.push('/payment-confirmation/' + this.state.currentFirmId);
    //       }, 0);
    //     }
    //   )
    //   .catch(error => {
    //     log.debug('submit error', error);
    //   })
    //   .finally(() => {
    //     log.debug('finally after submit');
    //   });
  }


  render() {
    const reduxObj = this.props.plan || {};
    const currentPlan = reduxObj.currentPlan;

    const planUser = currentPlan.planUser;
    const planName = currentPlan.planName;
    const planPeriod = currentPlan.planPeriod;
    const planPrice = currentPlan.planPrice;
    const planCurrency = currentPlan.planCurrency;

    const notPassedPlanInfo = (
      // this.state.reduxRefreshed &&
       (this.props.user || {}).UsrId && !planPrice);

    if (notPassedPlanInfo) {
      return <Redirect to='/dashboard' />;
    }

    const planNameLong = planName === 'E' ? 'Enterprise'
      : (planName === 'P' ? 'Professional'
        : (planName === 'C' ? 'Community' : 'Unknown'))




    const SubTestState = this.props.SubTest || {};

    if (SubTestState.access_denied) {
      return <Redirect to='/error' />;
    }

    const screenHlp = SubTestState.ScreenHlp;

    // Labels
    const siteTitle = (this.props.global || {}).pageTitle || '';
    log.debug(siteTitle);
    const MasterRecTitle = ((screenHlp || {}).MasterRecTitle || '');
    const MasterRecSubtitle = ((screenHlp || {}).MasterRecSubtitle || '');

    const screenButtons = SubTestReduxObj.GetScreenButtons(SubTestState) || {};
    const itemList = SubTestState.Dtl || [];
    const auxLabels = SubTestState.Label || {};
    const auxSystemLabels = SubTestState.SystemLabel || {};

    const columnLabel = SubTestState.ColumnLabel || {};
    const authCol = this.GetAuthCol(SubTestState);
    const authRow = (SubTestState.AuthRow || [])[0] || {};
    const currMst = ((this.props.SubTest || {}).Mst || {});
    const currDtl = ((this.props.SubTest || {}).EditDtl || {});
    const naviBar = getNaviBar('Mst', currMst, currDtl, screenButtons).filter(v => ((v.type !== 'Dtl' && v.type !== 'DtlList') || currMst.subTestId2));
    const selectList = SubTestReduxObj.SearchListToSelectList(SubTestState);
    const selectedMst = (selectList || []).filter(v => v.isSelected)[0] || {};
    const subTestId2 = currMst.subTestId2;
    const subTestDesc2 = currMst.subTestDesc2;
    const subDate2 = currMst.subDate2;
    const subUsrId2List = SubTestReduxObj.ScreenDdlSelectors.subUsrId2(SubTestState);
    const subUsrId2 = currMst.subUsrId2;

    const { dropdownMenuButtonList, bottomButtonList, hasDropdownMenuButton, hasBottomButton, hasRowButton } = this.state.Buttons;
    const hasActableButtons = hasBottomButton || hasRowButton || hasDropdownMenuButton;

    const isMobileView = this.state.isMobile;
    const useMobileView = (isMobileView && !(this.props.user || {}).desktopView);
    /* ReactRule: Master Render */
    /* ReactRule End: Master Render */

    return (
      <DocumentTitle title={siteTitle}>
        <div>
          <ModalDialog color={this.state.ModalColor} title={this.state.ModalTitle} onChange={this.OnModalReturn} ModalOpen={this.state.ModalOpen} message={this.state.ModalMsg} />
          <div className='account'>
            <div className='account__wrapper account-full-width'>
              <div className='account__card'>
                <div>
                  <div className="account-narrow">
                    <Formik
                      // initialValues={this.state.currentCreditCardPayment}
                      // key={this.state.currentCreditCardPaymentKey}
                      // validateOnChange={true}
                      // validateOnBlur={true}
                      // onSubmit={this.SubmitCreditCardPayment}
                      render={({
                        values,
                        errors,
                        touched,
                        isSubmitting,
                        dirty,
                        setFieldValue,
                        setFieldTouched,
                        handleChange,
                        submitForm,
                        setFieldError,
                      }) => (
                          <div>
                            {this.setDirtyFlag(dirty) &&
                              <Prompt
                                when={dirty}
                                message={auxSystemLabels.UnsavedPageMsg || ''}
                              />
                            }
                            <Form className='form'>
                              <div className='w-100'>
                                <Row>
                                  <Col sm={12} className="mb-15">
                                    <div className="payment-header">
                                      <p className='payment-header-type'>{planNameLong} Plan</p>
                                      <p className='payment-header-price'>{planCurrency} ${planPrice} {planPeriod && 'per ' + planPeriod}</p>
                                    </div>
                                  </Col>
                                </Row>
                                <p className="mb-20">Your account will be charged {planCurrency} ${toLocalAmountFormat(planPrice)} and will automatically renew every {planPeriod} unless cancelled. (You can cancel anytime.)</p>
                                <h4 className='account__title fw-600 mb-10'>Credit Card Details</h4>
                                <div className='form__form-group'>
                                  <StripeProvider apiKey={API_KEY}>
                                    <div className="example">
                                      <Elements>
                                        <StripeCheckoutForm
                                          history={this.props.history}
                                          onChange={this.CreditCardChanged}
                                        />
                                      </Elements>
                                    </div>
                                  </StripeProvider>
                                </div>
                              </div>
                            </Form>
                          </div>
                        )}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </DocumentTitle>
    );
  };
};

const mapStateToProps = (state) => ({
  user: (state.auth || {}).user,
  error: state.error,
  SubTest: state.SubTest,
  global: state.global,
  accountInfo: state.accountInfo,
  plan: state.plan,
  VwRUsrSubDtl: state.VwRUsrSubDtl,
});

const mapDispatchToProps = (dispatch) => (
  bindActionCreators(Object.assign({},
    { LoadPage: SubTestReduxObj.LoadPage.bind(SubTestReduxObj) },
    { LoadUserPage: VwRUsrSubDtlReduxObj.LoadPage.bind(VwRUsrSubDtlReduxObj) },
    { LoadUserInitPage: VwRUsrSubDtlReduxObj.LoadInitPage.bind(VwRUsrSubDtlReduxObj) },
    { SavePage: SubTestReduxObj.SavePage.bind(SubTestReduxObj) },
    { DelMst: SubTestReduxObj.DelMst.bind(SubTestReduxObj) },
    { AddMst: SubTestReduxObj.AddMst.bind(SubTestReduxObj) },
    //    { SearchMemberId64: SubTestReduxObj.SearchActions.SearchMemberId64.bind(SubTestReduxObj) },
    //    { SearchCurrencyId64: SubTestReduxObj.SearchActions.SearchCurrencyId64.bind(SubTestReduxObj) },
    //    { SearchCustomerJobId64: SubTestReduxObj.SearchActions.SearchCustomerJobId64.bind(SubTestReduxObj) },
    { SearchsubUsrId2: SubTestReduxObj.SearchActions.SearchsubUsrId2.bind(SubTestReduxObj) },
    { showNotification: showNotification },
    { setTitle: setTitle },
    { setSpinner: setSpinner },
    { setTopbarMenu: setTopbarMenu },
    { hideSidebar: hideSidebar },
    { hideTopbarMenu: hideTopbarMenu },
    { registerTopbarLeft: registerTopbarLeft },
    { registerTopbarCenter: registerTopbarCenter },
    { registerTopbarRight: registerTopbarRight },
    { loadPage: loadPage },
  ), dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(Payment);




// WEBPACK FOOTER //
// ./src/pages/Custom/Payment.js